export default "__VITE_ASSET__BmfWxVtv__"